module.exports = __webpack_public_path__ + "static/media/cart-thin.6adda2b8.svg";